import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "label", "option", "hiddenInputs"]
  static values  = {
    selected: Array,
    placeholder: String,
    name: String,
    selectedLabel: String,
  }

  connect() {
    this.selected = new Set(this.selectedValue.map(String))
    this.updateLabel()
    this._onOutsideClick = this._closeIfOutside.bind(this)
    document.addEventListener("click", this._onOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this._onOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle("hidden")
  }

  select(event) {
    const { value, label } = event.currentTarget.dataset
    this.selected.has(value) ? this.selected.delete(value) : this.selected.add(value)
    this._refreshOption(event.currentTarget)
    this.updateLabel()
    this._syncHiddenInputs()
  }

  updateLabel() {
    const count = this.selected.size
    if (count === 0) {
      this.labelTarget.textContent = this.placeholderValue || "All"
    } else if (count === 1) {
      const el = this.optionTargets.find(o => this.selected.has(o.dataset.value))
      this.labelTarget.textContent = el?.dataset.label ?? "1 select."
    } else {
      this.labelTarget.textContent = `${count} ${this.selectedLabelValue}`
    }
  }

  _refreshOption(el) {
    const active = this.selected.has(el.dataset.value)
    const check  = el.querySelector("svg")
    check.classList.toggle("visible",   active)
    check.classList.toggle("invisible", !active)
    el.classList.toggle("bg-primary",          active)
    el.classList.toggle("text-white",           active)
    el.classList.toggle("text-black",          !active)
    el.classList.toggle("hover:bg-secondary-light", !active)
  }

  _syncHiddenInputs() {
    this.hiddenInputsTarget.innerHTML = ""
    this.selected.forEach(value => {
      const input = document.createElement("input")
      input.type  = "hidden"
      input.name  = this.nameValue
      input.value = value
      this.hiddenInputsTarget.appendChild(input)
    })
  }

  _closeIfOutside(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden")
    }
  }
}